export default {
    validationHeader: 'Список ошибок:',
    message: 'Сообщение',
    nonData: 'Нет данных.',
    msgSearch: 'Поиск',
    error: 'Ошибка',
    guest: 'Гость',
    enumMonths: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
    ],
    aboutInf: {
        name: 'Портал<br>«Монетарные операции Национального банка»',
        version: 'Версия #serverVersion#clientVersion от #dateRelease',
        developer: 'Разработчик<br>Унитарное предприятие «Итбелком»',
        site: 'www.itbel.com',
    },
    application: {
        msgLogoutPopup: 'Вы уверены, что хотите выйти? Не отправленные в Национальный банк данные будут потеряны!',
        changeRout: 'Вы уверены, что хотите покинуть текущую страницу? Не отправленные в Национальный банк данные будут потеряны!',
        closeTitle: 'Закрыть приложение',
        noPermissionFromPortal: 'К сожалению, у Вас нет доступа к данному приложению.',
        errorUrlApplicationJson: 'Не найден Application Instance.'
    },
    articlesHomeClient: {
        notArticles: 'Нет статей.',
    },
    auctionResults: {
        registry: 'Реестр выпусков облигаций',
        lombCredits: 'Ломбардные кредиты',
        SWAP: 'Сделки СВОП',
        REPO: 'Прямое РЕПО',
        deposits: 'Депозиты',
        NBB_Bonds: 'Размещение облигаций (бел. рубли)',
        NBB_Bonds_Cur: 'Размещение облигаций (ин. валюта)',
        REPOreverse: 'Обратное РЕПО',
        resultsLombCredits: 'Итоги кредитных аукционов Национального банка Республики Беларусь',
        resultsSWAP: 'Итоги аукционов СВОП Национального банка Республики Беларусь',
        resultsREPO: 'Итоги проведения Национальным банком аукционов прямого РЕПО',
        resultsDeposits: 'Итоги депозитных аукционов Национального банка Республики Беларусь',
        resultsNBB_Bonds: 'Итоги размещения облигаций Национального банка Республики Беларусь, номинированных в белорусских рублях',
        resultsNBB_Bonds_Cur: 'Итоги размещения облигаций Национального банка Республики Беларусь, номинированных в иностранной валюте',
        resultsREPOreverse: 'Итоги проведения Национальным банком аукционов обратного РЕПО',
        messageNumberEntry1: 'Последние # строк включительно до аукциона №',
        messageNumberEntry2: 'Последние # строк включительно до выпуска',
        archive: 'Архив',
        tableType1: {
            legend: '* Форма аукциона: "об" – по объявленной ставке,<br>"ка" – конкурс процентных ставок по "американскому" способу,<br>"кг"– конкурс' +
                'процентных ставок по "голландскому" способу.<br>** При проведении аукциона по объявленной процентной ставке указана объявленная ставка.',
            th_number: 'Номер',
            th_date: 'Дата',
            th_form: 'Форма*',
            th_term: 'Срок,<br>дней',
            th_count_participant: 'Коли-<br>чество<br>участ-<br>ников',
            th_count_participant_sucess: 'Количество<br>участников, заявки<br>которых были<br>удовлетворены',
            th_count_request: 'Количество<br>заявок,<br>допущенных<br>к участию<br>в аукционе',
            th_count_sucess: 'Количество<br>удовлетворенных<br>заявок',
            th_demand: 'Перво-<br>начальный<br>спрос,<br>млн. рублей',
            th_volume: 'Объем удовле-<br>творенных<br>заявок,<br>млн. рублей',
            th_bet: 'Ставка отсечения**,<br>% годовых',
            th_arm: 'Средне-<br>взвешенная<br>процентная ставка**,<br>% годовых',
            th_min: 'Минимальная<br>ставка,<br>предложен-<br>ная банками,<br>% годовых',
            th_max: 'Максимальная<br>ставка,<br>предложен-<br>ная банками,<br>% годовых',
            th_number_release: 'Номер<br>выпуска',
            th_count_request_short: 'Количество<br>заявок,<br>допущенных<br>к участию',
            th_volume_factual: 'Фактический<br>объем<br>сделок,<br>млн. рублей',
        },
        tableType2: {
            legend: '* Процедура размещения:"ак" – аукцион процентных ставок;<br>"ао" – аукцион по объявленной процентной ставке;' +
                '<br>"дк" – доразмещение путем проведения аукциона процентных ставок;<br>"до" – доразмещение по объявленной процентной ставке;' +
                '<br>"п" – продажа без проведения аукциона(до 01.01.2017);<br>"пд" – доразмещение выпуска проданного без проведения' +
                'аукциона(до 01.01.2017);<br>"з" – закрытая продажа(с 01.01.2017).',
            legend_Cur: '* Процедура размещения:<br>"ак" – аукцион процентных ставок;<br>"ао" – аукцион по объявленной' +
                ' процентной ставке;<br>"дк"– доразмещение путем проведения аукциона процентных ставок;' +
                '<br>"до" – доразмещение по объявленной процентной ставке;<br>"з" – закрытая продажа.',
            th_name_release: 'Название выпуска /<br>Решение о выпуске',
            th_placement_procedure: 'Про-<br>це-<br>дура<br>раз-<br>меще-<br>ния*',
            th_date_of_the: 'Дата проведения',
            th_maturity_date: 'Дата погашения',
            th_circulation_term: 'Срок обра-<br>щения, дней',
            th_volume_issue: 'Объем эмиссии, млн.',
            th_currency_value: 'Валю-та номи-нала',
            th_actual_demand: 'Факти-ческий спрос, млн.',
            th_placed_par: 'Размещено по номиналу, млн.',
            th_hosted_fact: 'Размещено фактически, млн.',
            th_bet: 'Ставка отсечения, % годовых',
            th_arm: 'Средне-взвешен-ная ставка, % годовых',
            th_min: 'Мини-мальная ставка, предло-женная участниками, % годовых',
            th_max: 'Макси-мальная ставка, предло-женная участниками, % годовых',
            th_number_participants: 'Коли-<br>чество участ-<br>ников',
            th_number_participants_sucess: 'Коли-чество участ-ников, заявки которых были удовле-творены',
            th_number_proposals: 'Ко–<br>личест-<br>во предло-<br>жений, допу-<br>щенных к уча-<br>стию в аук-<br>ционе',
            th_number_satisfied_proposals: 'Коли-чество  удовлет-воренных предло-жений',
            th_current_cost: 'Теку-<br>щая стои-<br>мость',
        },
    },
    backnav: {
        home: 'Главная',
        arrowRight: '→',
        registry: 'Реестр выпусков облигаций Национального Банка',
        issueDecision: 'Решение о выпуске',
        ditails: 'Подробнее',
    },
    charts: {
        header: 'Дни, в которые Национальный банк не проводит сделки СВОП по соответствующим валютам*',
        legend: 'Применительно к инструкции Национального банка от 08.02.2013 № 76',
        table: {
            th_date: 'Дата',
            th_currency: 'Валюта',
        },
    },
    chat: {
        allUserContact: 'Всем',
        placeholderForMessage: 'Введите сообщение...',
        placeholderForSearch: 'Поиск контакта...',
        search: 'Поиск',
        deleteGroupConfirm: 'Вы действительно хотите удалить выбранную группу?',
        newGroupButtonTooltip: 'Создать группу',
        editGroupButtonTooltip: 'Редактировать группу',
        dellGroupButtonTooltip: 'Удалить группу',
        dialog: 'Беседка',
        nbrb: 'НБ РБ',
        cancelUploadButton: 'Отменить загрузку',
        hello: 'Здравствуйте',
        sendFile: 'Переслать файл',
        contextMenu: 'Дополнительно',
        sendMessage: 'Отправить сообщение',
        closeEditMessage: 'Отменить редактирование',
        editMessageTime: 'изменено #editDate в #editTime',
        edit: 'Изменить',
        entryMessage: 'печатает',
        tabs: {
            default: 'Контакты',
            recent: 'Недавние'
        },
        dateAliases: {
            today: 'сегодня',
            yesterday: 'вчера',
        },
        uploadSizeExceeded: 'Загружаемый файл слишком большой. Максимальный допустимый размер файла 50 МВ.',
        awaitDownload: 'Файл готовится к скачиванию...'
    },
    contactsHomeClient: {
        outher: 'Другие'
    },
    detailsRegistry: {
        headerCurrentBel: 'Параметры #-го выпуска краткосрочных облигаций Национального банка Республики Беларусь',
        headerCurrentInv: 'Параметры #-го выпуска облигаций Национального банка Республики Беларусь с процентным доходом,' +
            'номинированных в свободно конвертируемой валюте, для юридических лиц',
        headerIssueDecision: 'Решение о # выпуске облигаций Национального банка Республики Беларусь',
        backLink: 'Вернуться в реестр',
        plannedOperations: 'Планируемые операции',
        discount: 'дисконтные',
        interest: 'процентные',
        long_term: 'долгосрочные',
        short_term: 'краткосрочные',
        table: {
            td_parameter_name: 'Название параметра',
            td_value_name: 'Значение параметра',
            td_date_issue: 'Дата выпуска',
            td_issue_number: 'Номер выпуска',
            td_circulation_term: 'Срок обращения облигаций, дней',
            td_maturity_date: 'Дата погашения облигаций',
            td_registration_number: 'Регистрационный номер выпуска облигаций',
            td_name_currency: 'Наименование иностранной валюты, в которой номинированы облигации',
            td_number_bonds: 'Количество облигаций, штук',
            td_volume_emissions: 'Объем эмиссии облигаций в валюте номинала',
            td_nominal_cost: 'Номинальная стоимость одной облигации',
            td_type_income: 'Тип дохода',
            td_rate_income: 'Ставка дохода, % годовых',
            td_date_start: 'Дата начала размещения облигаций',
            td_circulation: 'Порядок обращения облигаций на вторичном рынке',
            td_bond_holders: 'Владельцы облигаций по данному выпуску',
            td_procedure_determining: 'Порядок определения ставки процентного дохода, % годовых',
            td_bid_terms: 'Условия определения ставки',
            td_bid_terms_text: 'ставка LIBOR определяется на дату эмиссии и действует в течение всего срока обращения облигаций',
            td_interest_payment_dates: 'Даты выплаты процентного дохода',
            td_bond_placement_period: 'Период размещения облигаций',
            td_bond_sale_price: 'Цена продажи облигаций',
        },
        tableIssueDecision: {
            td_type_bonds: 'Вид облигаций',
            td_registration_number: 'Регистрационный номер выпуска',
            td_number_bonds: 'Количество облигаций в выпуске',
            td_volume_issue: 'Объем выпуска',
            td_nominal_cost: 'Номинальная стоимость',
            td_currency: 'Валюта, в которой выражена номинальная стоимость',
            td_placement_method: 'Способ размещения',
            td_date_start: 'Дата начала размещения',
            td_maturity_date: 'Дата погашения',
            td_circulation_term: 'Срок обращения',
            td_period_placement: 'Период размещения',
            td_amount: 'Размер дохода или порядок его определения',
            td_periodicity: 'Периодичность выплаты дохода',
            td_date_income: 'Даты выплаты дохода',
            td_investors: 'Инвесторы по данному выпуску облигаций',
            td_features_treatment: 'Особенности обращения облигаций данного выпуска',
            td_early_repayment: 'Условия и порядок досрочного погашения выпуска облигаций либо его части',
            td_bond_redemption: 'Условия и порядок выкупа облигаций Национальным банком',
            td_order_information: 'Информация о порядке и условиях конвертации облигаций данного\
             выпуска в облигации другого выпуска с более поздней датой погашения',
        }
    },
    homePage: {
        notNews: 'Нет новостей.',
        moreInf: 'Подробнее...',
        newNewsNotification: 'Появилась новость. Нажмите, чтобы перейти к ней.',
        updated: 'изменено #date в',
    },
    interestRates: {
        currency: 'Валюта',
        td_dollar: 'доллар США',
        td_euro: 'евро',
        td_russian_ruble: 'российский рубль',
        header: 'Cтавки по операциям Национального банка Республики Беларусь на финансовом рынке',
        header_small_table: 'Процентные ставки за пользование денежными средствами в иностранной валюте по сделкам СВОП',
        archive2: 'Архив с 17.03.2008',
        table: {
            th_operations: 'Операции',
            th_term: 'Срок<br>(дней)',
            td_permanently_available_operations: 'Постоянно доступные операции',
            td_overnight_credit: 'кредит овернайт',
            td_overnight_swap: 'СВОП овернайт (по национальной валюте)',
            td_overnight_deposits: 'депозиты овернайт',
            td_bilateral_operations: 'Двусторонние операции',
            td_lombard_loan_fixed_rate: 'ломбардный кредит по фиксированной ставке',
            td_swap_transactions: 'сделки СВОП (по национальной валюте)',
            td_open_market_operations: 'Операции на открытом рынке',
            td_lombard_loan_auction_basis: 'ломбардный кредит на аукционной основе',
            td_purchase_securities_REPO_terms: 'покупка ценных бумаг на условиях РЕПО',
            td_swap_auction_deals: 'аукционные сделки СВОП',
            td_auction_based_deposits: 'депозиты на аукционной основе',
            td_issue_bondsNB: 'эмиссия облигаций Национального банка',
            td_REPO_terms: 'продажа ценных бумаг на условиях РЕПО',
            days1: '1 рабочий день',
            days30: 'не более 30<br>календарных дней',
            mount3: 'не более<br>3 месяцев',
            year1: 'не более 1 года',
        }
    },
    linksHomeClient: {
        toolbarHeader: 'Поддержка → Руководства пользователя',
        outher: 'Прочие документы'
    },
    loanList: {
        fileExcel: 'В файле Excel',
        header: 'Перечень ценных бумаг, принимаемых Национальным банком Республики Беларусь в качестве обеспечения ломбардных и других кредитов* на ',
        legend: 'Перечень составлен с учётом  требований, изложенных в Постановлении Правления Национального банка от 18 октября 2006' +
            'г.№ 153 "Об утверждении ломбардного списка ценных бумаг, принимаемых Национальным банком Республики Беларусь в качестве' +
            'обеспечения ломбардных и других кредитов".',
        table: {
            th_number: '№ п/п',
            th_issuer: 'Эмитент',
            th_issue_number: 'Номер выпуска',
            th_issue_code_RCSD: 'Код выпуска РЦДЦБ',
            th_registration_number: 'Регистрационный номер',
            th_collateral_ratio: 'Коэффициент обеспечения обязательств',
            volume_issue: 'Объем эмиссии по данному виду ценных бумаг: # руб.',
            volume_issue_all: 'Объем эмиссии по всем ценным бумагам перечня: # руб.',
            lombList: 'Ломбардный список ценных бумаг, принимаемых Национальным банком Республики Беларусь в качестве обеспечения ломбардных и других кредитов',
        }
    },
    localSessionStorage: {
        logoTitle: 'Монетарные операции НБ РБ',
        pathToStorageForChrome:
            'Свойства браузера → Дополнительные → Конфиденциальность и безопасность → Файлы Cookie → Разрешить сайтам сохранять и читать файлы cookie',
        pathToStorageForIE: 'Настройки → Дополнительно → Безопасность → Включить хранилище DOM',
        pathToStorageForEdge: 'Свойства браузера → Конфиденциальность и безопасность → Cookies → Не блокировать Cookies',
        enableStorageDOM: 'Необходимо включить хранилище DOM'
    },
    login: {
        modalHeader: 'Смена пароля',
        loginTab: 'Вход с использованием пароля',
        digitalSignatureTab: 'Вход с использованием ЭЦП',
        loginPlace: 'Логин',
        passwordPlace: 'Пароль',
        passwordNew: 'Новый пароль',
        differentPasswords: 'Пароли не совпадают',
        passwordConfirm: 'Подтверждение пароля',
        saveButton: 'Сохранить',
        button: 'Войти',
        logoTitle: 'Монетарные операции НБ РБ',
        container: 'Контейнер',
        notPermissionInputApp: 'Для входа в приложение, сначала необходимо авторизироваться с контейнером.',
        linkToDownload: 'Скачать программу для работы с ЭЦП',
    },    
    lombList: {
        headerTable: 'Ломбардный список ценных бумаг, принимаемых Национальным банком Республики Беларусь в качестве обеспечения ломбардных и других кредитов',
        detailed: 'Подробный перечень',
        table: {
            th_number: '№ п/п',
            th_name_securities: 'Наименование ценных бумаг',
            th_collateral_ratio: 'Коэффициент обеспечения обязательств',
            th_foreign_currency: 'Иностранная валюта',
            td_dollar: '1. Доллар США',
            td_euro: '2. Евро',
            td_russian_ruble: '3. Российский рубль',
        },
        securities: 'Ценные бумаги, включенные в ломбардный список, принимаются Национальным банком Республики Беларусь' +
            ' в качестве обеспечения ломбардных и других кредитов при выполнении следующих условий:',
        li_securities: 'ценные бумаги допущены к обращению на торгах в открытом акционерном обществе "Белорусская валютно-фондовая биржа";',
        li_bank: 'банк, предоставляющий ценные бумаги в залог, не является эмитентом таких ценных бумаг.',
        headerTableList: 'Перечень иностранных валют, в которых Национальным банком Республики Беларусь' +
            ' принимаются гарантийные депозиты в качестве обеспечения кредитов',
    },
    menu: {
        mMsg: 'Сообщения',
        operativeInformation: 'Оперативная информация',
        percent: 'Ставки, обеспечение',
        auctions: 'Итоги аукционов',
        charts: 'Графики, регламенты',
        documents: 'Нормативные документы',
        support: 'Поддержка',
        guestRegistration: 'Регистрация гостя',
        supportChild: {
            contacts: 'Контакты',
            userGuide: 'Руководства пользователя',
            techRequirements: 'Аппаратно - программные требования',
        },
        apps: 'Программы',
        appsChild: {
            electronic_auction: 'Размещение облигаций НБ',
            pledge: 'Управление залогом',
            deposit: 'Депозиты небанковских организаций',
            deposit_auction: 'Депозиты банков',
            electronic_auction_test: 'Размещение облигаций НБ (тест)',
            pledge_test: 'Управление залогом (тест)',
            deposit_test: 'Депозиты небанковских организаций (тест)',
        },
    },
    menuCategory: {
        news: 'Новости портала',
        messages: 'Новости сайта НБ РБ',
        plannedOperationsBel: 'Планируемые операции (бел. рубли)',
        plannedOperations: 'Планируемые операции (ин. валюта)',
        subjectSpecialists: 'Предметные специалисты',
        technicalSpecialists: 'Технические специалисты',
        percent: 'Ставки по операциям',
        typesSecurity: 'Виды обеспечения',
        lombardList: 'Подробный перечень ценных бумаг, входящий в ломбардный список',
        opsTiming: 'Временной регламент операций',
        holidaysSWAP: 'Нерабочие дни по инвалютам',
        schedule: 'График основных операций',
        scheduleFX: 'График аукционов по размещению облигаций в иностранной валюте',
    },
    operativeInformation: {
        liquidity_management: 'Ближайшие планируемые операции по регулированию ликвидности',
        liquidity_management_cur: 'Ближайшие планируемые операции по размещению облигаций Национального банка, номинированных в иностранной валюте',
        liquidity_support_operations: 'Операции поддержания ликвидности',
        liquidity_withdrawals: 'Операции изъятия ликвидности',
        headerTableCreditAuction: 'Кредитный аукцион',
        headerTableAuctionSWAP: 'Аукцион СВОП',
        headerTableAuctionDirectREPO: 'Аукцион прямого РЕПО',
        headerTableAuctionDeposit: 'Депозитный аукцион',
        headerTableAuctionPlacingBondsNB: 'Аукцион по размещению облигаций Национального банка',
        headerTableAuctionAdditionalPlacement: 'Доразмещение облигаций Национального банка',
        headerTableAuctionReverseREPOAuction: 'Аукцион обратного РЕПО',
        headerTableClosedSale: 'Проведение закрытой продажи облигации',
        links: 'График аукционов по размещению облигаций Национального банка, номинированных в иностранной валюте',
        notLimited: 'не ограничивается',
        defaultVolume: 'открытый',
        fromTimeToTime: 'с #from до #to',
        fromDateToDate: 'с #from по #to',
        accountFormat: '#accNum в Национальном банке, БИК #mfoCode',
        correspondentAccount: '#corrAccNum в #corrBankTitle, #corrBankSwiftCode',
        noOperations: 'Операции не запланированы.',
        table: {
            td_date: 'Дата проведения',
            td_number_auction: 'Номер аукциона',
            td_form_auction: 'Форма аукциона',
            td_method_satisfaction_applications: 'Способ удовлетворения заявок',
            td_term_use_credit: 'Срок пользования кредитом, дней',
            td_rate: 'Ставка, % годовых',
            td_min_rate: 'Минимальная ставка, % годовых',
            td_max_rate: 'Максимальная ставка, % годовых',
            td_volume: 'Объем подачи неконкурентных заявок (в процентах от общего объема)',
            td_term_deals: 'Срок сделок, дней',
            td_term_transaction: 'Срок сделок, дней',
            td_date_direct_transaction: 'Дата валютирования по прямым сделкам',
            td_date_reverse_transaction: 'Дата валютирования по обратным сделкам',
            td_rate_bel: 'Ставка по белорусским рублям, % годовых',
            td_min_rate_bel: 'Минимальная ставка по белорусским рублям, % годовых',
            td_max_rate_bel: 'Максимальная ставка по белорусским рублям, % годовых',
            td_volume_short: 'Объем подачи неконкурентных заявок',
            td_securities: 'Ценные бумаги, с которыми проводятся операции',
            td_bond_price: 'Цена облигации по первой части сделки',
            td_min_volume: 'Минимальный объем одной конкурентной заявки, млн. рублей',
            td_noncompetitive_bid_limit: 'Лимит неконкурентного предложения',
            td_maximum_number_applications: 'Максимальное количество заявок от одного участника',
            td_application_time: 'Время подачи заявок',
            td_time_satisfy_requests: 'Время удовлетворения заявок',
            td_date_acceptance_deposit: 'Дата приема денежных средств в депозит',
            td_term_attraction_deposit: 'Срок привлечения депозита, дней',
            td_date_return_deposit: 'Дата возврата депозита',
            td_rate_long: 'Cтавка, % годовых (доходность для инвестора)',
            td_multiplicity_amount: 'Кратность суммы в заявках, рублей',
            td_min_sum_deposit: 'Минимальная сумма депозита, млн.рублей',
            td_feed_amount: 'Объем подачи неконкурентных заявок',
            td_min_size: 'Минимальный размер денежных средств, перечисляемых в качестве задатка, % от суммы заявок',
            td_registration_number_issue: 'Регистрационный номер выпуска',
            td_circulation_term: 'Срок обращения, дней',
            td_maturity_date: 'Дата погашения',
            td_volume_issue: 'Объем выпуска',
            td_currency: 'Валюта, в которой выражена номинальная стоимость',
            td_minimum_participation_limit: 'Лимит минимального участия первичного инвестора',
            td_limit_noncompetitive: 'Лимит неконкурентного предложения (в процентах от общего объема заявки первичного инвестора)',
            td_period_satisfaction_applications: 'Период удовлетворения заявок',
            td_account_transfer_funds: 'Счет для перечисления денежных средств',
            td_term_transfer_funds: 'Срок перечисления денежных средств в оплату приобретенных на аукционе облигаций',
            td_bond_issue_parameters: 'Параметры выпуска облигаций',
            td_volume_placement: 'Объем доразмещения, штук',
            td_issue_securities: 'Выпуск ценных бумаг, с которым проводятся операции',
            td_term_operations: 'Срок операций, дней',
            td_max_volume_operations: 'Максимальный объем операций, млн.рублей',
            td_bond_price_rub: 'Цена облигации по второй части сделки, рублей',
            td_limit_noncompetitive_short: 'Лимит неконкурентного предложения (в процентах от общего объема заявки первичного инвестора)',
            td_max_number_applications: 'Максимальное количество заявок от одного участника',
            td_correspondent_account: 'Корреспондентский счет Национального банка для перечисления денежных средств через банки-нерезиденты',
            td_terms_transfer: 'Условия перечисления денежных средств',
            td_date_closed_sale: 'Дата (период) проведения закрытой продажи',
            td_volume_sale: 'Объем продажи, штук',
        }
    },
    popupGroupEdit: {
        edit: 'Редактирование группы',
        create: 'Создание группы',
        groupTitle: 'Наименование группы',
        allContacts: 'Все контакты',
        usersInGroup: 'Пользователи в группе',
    },
    profile: {
        title: 'Профиль - #',
        titleImage: 'Фото',
        editProfile: 'Редактировать профиль',
        subscribe: 'Подписаться',
        unsubscribe: 'Отписаться',
        subcategoryTitle: 'Подписка на новости:',
        subcategoryMessage: 'Получать уведомления по электронной почте о новостях в категориях:',
        AllSubcategory: 'Все категории'
    },
    registry: {
        prev: 'Предыдущая',
        next: 'Следующая',
        header: 'Реестр выпусков облигаций Национального банка Республики Беларусь по состоянию на #',
        displayResults: 'Отображать результатов:',
        legend: '* КО НБ - Краткосрочные облигации Национального банка<br>ВО НБ физ. - Облигации Национального банка на предъявителя,' +
            'номинированные в иностранной валюте<br>О НБ - Облигации Национального банка<br>ВО НБ - Облигации  Национального банка' +
            'с процентным доходом, номинированные в свободно конвертируемой валюте, для юридических лиц',
        infoLink: 'Нормативные правовые акты, регулирующие выпуск облигаций Национального банка',
        details: 'подробнее',
        issueDecision: 'решение о выпуске',
        placeholderInput: 'Поиск или фильтрация результатов...',
        nominativDeclensionDayWord: 'день',
        genetivDeclensionDayWord: 'дня',
        pluralDeclensionDayWord: 'дней',
        currentCost: 'текущая стоимость',
        filter: {
            pressenter: 'Нажмите Enter или кликните для поиска',
            filterTypeTitle: 'вид облигации',
            filterStatusTitle: 'статус',
            filterNumberTitle: 'порядковый номер выпуска',
            filterStartDateTitle: 'показать с',
            filterEndDateTitle: 'показать по',
            value: ':значение',
            msgInputNumber: 'Введите число',
            msgClickForSave: 'Нажмите, чтобы выбрать число',
            noMatchingEntries: 'Нет подходящих записей',
        },
        table: {
            td_type: 'Тип*',
            td_number: 'Поряд-<br>ковый<br>номер<br>выпуска',
            td_date_start: 'Дата<br>начала<br>обращения',
            td_date_end: 'Дата<br>окончания<br>обращения',
            td_circulation_term: 'Срок<br>обра-<br>щения,<br>дней',
            td_registration_number: 'Регистра-<br>ционный<br>номер<br>выпуска',
            td_nominal_cost: 'Номинальная<br>стоимость<br>(в валюте<br>номинала)',
            td_currency: 'Валюта<br>номи-<br>нала',
            td_volume_emissions: 'Объем<br>эмиссии',
            td_volume_appeal: 'Объем<br>в обращении<br>по номинальной<br>стоимости',
            td_income: 'Доход-<br>ность, % годовых',
            td_investors: 'Инвесторы',
            td_status: 'Статус',
            td_additionally: 'Дополнительно',
            td_isin: 'ISIN: ',
            td_cfi: 'CFI: ',
            td_fisn: 'FISN: ',
            td_securities_codes: 'Междуна-<br>родные коды ценной бумаги'
        }
    },
    sidebar: {
        collapse: 'Свернуть',
        expand: 'Развернуть',
        editProfile: 'Редактировать профиль',
    },
    topmenu: {
        operationTitle: 'Монетарные операции НБ РБ',
        about: 'О системе',
        logout: 'Выйти',
        login: 'Войти',
        searchSite: 'Поиск по сайту',
        panelControl: 'Панель управления'
    },
    guestList: {
        numberRowsTable: '№ п/п',
        notGuests: 'Нет пользователей.',
        confirmDeleteTextMsg: 'Вы действительно хотите удалить выбранного пользователя?',
        fio: 'Ф.И.О.',
        dateRegistration: 'Дата регистрации',
        deleteUserError: 'Невозможно удалить пользователя!',
        actions: 'Управление',
        login: 'Логин',
        author: 'Исполнитель',
        notUsers: 'Нет пользователей',

    },
    guestEditor: {
        headerPageView: 'Просмотр карточки гостя',
        headerPageEdit: 'Редактирование карточки гостя',
        headerPageCreate: 'Регистрация гостя',
        lastName: 'Фамилия',
        firstName: 'Имя',
        secondName: 'Отчество',
        password: 'Пароль',
        stayOnPageMsg: 'Несохраненные данные будут потеряны! Остаться на странице?',
        errorSave: 'Произошла ошибка при сохранении! Повторите попытку позже.',
        nameDuplicatedText: 'Пользователь с заданным ФИО уже существует! Продолжить?',
        cancelWithoutSave: 'Отменить произведённые изменения?'
    },
    modalDualListbox: {
        title: 'Настройки',
        selected: 'Выбранные',
        notSelected: 'Доступные',
        searchPlaceholder: 'Поиск...',       
        confirmDeleteTextMsg: 'Вы действительно хотите удалить выбранного пользователя?',
    },
    pageNotFound: {
        header: 'Запрашиваемая страница не найдена!',
        goBack: 'Вернуться назад',
    },
};


// WEBPACK FOOTER //
// ./user/localization/ru/textMessages.ts